import { unique } from '@portals-platform/utils';
import type { CaptivePolicy } from '../../data-access/models.js';

const policyYearOf = (policy: CaptivePolicy): string =>
  policy.policyYear === null ? '' : String(policy.policyYear);

export const getPolicyYearOptions = (policies: CaptivePolicy[] = []): string[] =>
  unique(policies.map(policyYearOf)).sort();

export const getPolicyForYear = ({
  policies,
  policyYear,
}: {
  policies: CaptivePolicy[];
  policyYear: string;
}): CaptivePolicy | null => {
  if (!policyYear) {
    return null;
  }

  return policies.find((policy) => policyYearOf(policy) === String(policyYear)) ?? null;
};

export const buildDefaultCertificatePolicyNumber = (policyYear: string): string =>
  policyYear ? `CERT-${policyYear}-001` : '';
